import type { PDFSeparationFunction } from "@pdfking/renderer-api"
import {
  BlobArray,
  BlobCreate,
  BlobToUint8,
  UrlLoad,
} from "@pdfking/compatibility"
import { Provision } from "@pdfking/ghostscript"
import { PSOcoated_v3_small as DefaultICC } from "@pdfking/icc"
import { IterableToArray } from "@pdfking/tfunc"

export const PDFSeparation: PDFSeparationFunction = (input, options) =>
  Provision(async function* (api) {
    const [data, icc] = await Promise.all([
      IterableToArray(input.stream).then(BlobArray).then(BlobToUint8),
      UrlLoad(input.icc ?? DefaultICC).then(r => r.arrayBuffer()).then(b => new Uint8Array(b)),
    ])

    const { value: result, error } = await api.create_separation({
      data,
      icc,
      ...options,
    })
    if (error) throw error
    yield {
      channels: result.channels.map(c => ({
        channel: c.channel,
        blob: BlobCreate(c.bytes, "image/tiff"),
      })),
      page: result.page,
      width: result.width,
      height: result.height,
    }
  })
